import React, { useEffect } from "react";
import { aggregationFns } from "../aggregation-fns";
import Typography from "../../typography/typography";
import { MenuItem } from "@mui/material";
import Menu from "../../menu/menu";
import { MRT_RowData } from "material-react-table";

type aggregationType =
  | "none"
  | "avg"
  | "min"
  | "max"
  | "count_empty"
  | "count_full"
  | "sum"
  | "percentage_empty"
  | "percentage_full";

interface IAggregation {
  label: string;
  value: aggregationType;
}

const allAggregations: IAggregation[] = [
  {
    label: "Average",
    value: "avg",
  },
  {
    label: "Sum",
    value: "sum",
  },
  {
    label: "Min",
    value: "min",
  },
  {
    label: "Max",
    value: "max",
  },
  {
    label: "Count Empty",
    value: "count_empty",
  },
  {
    label: "Count Full",
    value: "count_full",
  },
  {
    label: "Percentage Full",
    value: "percentage_full",
  },
  {
    label: "Percentage Empty",
    value: "percentage_empty",
  },
  {
    label: "None",
    value: "none",
  },
];

const nonNumberAggregations: IAggregation[] = [
  {
    label: "Count Empty",
    value: "count_empty",
  },
  {
    label: "Count Full",
    value: "count_full",
  },
  {
    label: "Percentage Full",
    value: "percentage_full",
  },
  {
    label: "Percentage Empty",
    value: "percentage_empty",
  },
  {
    label: "None",
    value: "none",
  },
];

const aggregationFnsLookup = {
  avg: aggregationFns.average,
  sum: aggregationFns.sum,
  max: aggregationFns.max,
  count_empty: aggregationFns.countEmpty,
  count_full: aggregationFns.countFull,
  percentage_empty: aggregationFns.percentageEmpty,
  percentage_full: aggregationFns.percentageFull,
  min: aggregationFns.min,
  none: aggregationFns.none,
};

interface INumberAggregation {
  data: MRT_RowData[];
  column: string;
  type?: string;
}

const NumberAggregation = ({ data, column, type }: INumberAggregation) => {
  const [selectedType, setSelectedType] =
    React.useState<aggregationType>("none");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [calculatedValue, setCalculatedValue] = React.useState<string | null>();
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAggregationType = (val: aggregationType) => {
    setSelectedType(val);
    handleClose();
  };

  useEffect(() => {
    const func = aggregationFnsLookup[selectedType];
    setCalculatedValue(func(data, column));
  }, [selectedType, column, data]);

  const aggregations =
    type === "number" ? allAggregations : nonNumberAggregations;

  return (
    <>
      <Typography
        onClick={handleClick}
        sx={{ cursor: "pointer" }}
        type="s4"
        weight="normal"
        color={calculatedValue ? "theme.secondary.1000" : "theme.secondary.500"}
      >
        {calculatedValue || "+ Add Calculation"}
      </Typography>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {aggregations?.map((aggr) => (
          <MenuItem
            key={aggr.value}
            selected={selectedType == aggr?.value}
            onClick={() => handleAggregationType(aggr?.value)}
          >
            <Typography color="theme.secondary.1000" type="s4">
              {aggr?.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export { NumberAggregation };
export default NumberAggregation;
